// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"432":"b0c4303f","540":"783bcd82","720":"3eaf7696"}[chunkId] + ".chunk.js";
};